var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['step', { completed: _vm.step > _vm.number }, { active: _vm.step == _vm.number }],attrs:{"data-step":_vm.number}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.name))]),_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.number))])])
}
var staticRenderFns = []

export { render, staticRenderFns }